import { useUserPreferences } from "@/context/UserPreferencesContext";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { preferences } = useUserPreferences();
  const theme = preferences?.theme_mode || "dark";

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      // Top-center, not the sonner default of bottom-right: bottom-right is
      // exactly where quiz answer choices and every fixed bottom action bar
      // in the app (BottomNav, the quiz Prev/Next bar, PrimaryAction, chat
      // input) already live, so a toast there was guaranteed to collide with
      // something. Top-center stays clear of all of them.
      position="top-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          // Soft rounded + a translucent surface with blur, matching the
          // Experience System's cards/modals (GlassCard, AlertDialog) instead
          // of the previous hard-cornered, flat-opaque look.
          toast:
            "group toast group-[.toaster]:bg-[rgba(var(--bg-surface-rgb),0.92)] group-[.toaster]:backdrop-blur-xl group-[.toaster]:text-[var(--text-primary)] group-[.toaster]:border-[var(--border-default)] group-[.toaster]:rounded-2xl group-[.toaster]:shadow-xl",
          description: "group-[.toast]:text-[var(--text-secondary)]",
          actionButton:
            "group-[.toast]:bg-[var(--accent-primary)] group-[.toast]:text-[var(--text-on-accent)] group-[.toast]:rounded-xl",
          cancelButton:
            "group-[.toast]:bg-[var(--bg-surface-2)] group-[.toast]:text-[var(--text-secondary)] group-[.toast]:rounded-xl",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
